import { jsx as r } from "react/jsx-runtime";

import { memo as e, useMemo as t } from "react";

import { DEFAULT_MARKDOWN_RENDERERS as a, Markdown as n } from "react-marked-renderer";

import s from "../../utils/classNames/index.js";

const o = e => ({
    ...a,
    link: t => r("a", {
        ...t,
        className: "secondary" === e ? "text-link-secondary" : "text-link-primary",
        rel: "noreferrer",
        target: "_blank"
    }),
    list: e => {
        const {ordered: t, start: n} = e;
        return t && n && n > 1 ? r("ol", {
            start: n,
            children: e.children
        }) : r(a.list, {
            ...e
        });
    }
}), l = {
    breaks: !0,
    gfm: !0
}, i = e((({content: e, renderers: a, options: i, className: c, linkVariant: m = "primary", ...d}) => {
    const p = t((() => (r => r ? r.replace(/<br\s*\/?>/g, "\n").replace(/&nbsp;/g, " ").replace(/^[ \t]+/gm, "") : "")(e)), [ e ]), k = t((() => ({
        ...o(m),
        ...a
    })), [ a, m ]), f = t((() => ({
        ...l,
        ...i
    })), [ i ]);
    return p ? r("div", {
        ...d,
        className: s("prose prose-neutral", c),
        children: r(n, {
            markdown: p,
            options: f,
            renderers: k
        })
    }) : null;
}));

export { i as default };
//# sourceMappingURL=index.js.map
